import type { PaginationResponse } from '@/types/PaginationResponse';

export const getPreviousPageParam = (
  firstPage: Record<string, any>
): Record<string, any> | undefined => {
  return firstPage ?? undefined;
};

export const getNextPageParam = ({
  pagination,
}: {
  pagination: PaginationResponse<void>['pagination'];
}): { current: number } | undefined => {
  return pagination.current < Math.ceil(pagination.total / pagination.page_size)
    ? { current: pagination.current + 1 }
    : undefined;
};
